/* eslint-disable react/jsx-no-bind */
import { Settings } from '@mui/icons-material';
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  CardContent,
  Card,
  TablePagination,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Checkbox,
  MenuItem,
  TextareaAutosize,
  useTheme,
  Divider,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { tokens } from '../../theme';
import logger from '../../utils/logger';

import roleService from './roleService';

// const initialData = [
//   {
//     id: 1,
//     role_name: "V3C Driver",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 2,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 3,
//     role_name: "V3C Admin",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 4,
//     role_name: "V3C Driver",
//     description: "namasthe",

//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 5,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 6,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 7,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
//   {
//     id: 8,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },

//   {
//     id: 9,
//     role_name: "V3C Manager",
//     description: "namasthe",
//     permissions: [
//       { asset: "Monitor", read: true, write: false, delete: true },
//       { asset: "Plans", read: false, write: true, delete: true },
//       { asset: "Users", read: true, write: false, delete: false },
//       { asset: "OAuth", read: false, write: true, delete: false },
//     ],
//   },
// ];

const initialPermissions = [
  { asset: 'Monitor', read: false, write: false, delete: false },
  { asset: 'Plans', read: false, write: false, delete: false },
  { asset: 'Users', read: false, write: false, delete: false },
  { asset: 'OAuth', read: false, write: false, delete: false },
];

const Role = () => {
  const [roles, setRoles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [roleName, setRoleName] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [permissions, setPermissions] = useState(initialPermissions);
  const [selectedRole, setSelectedRole] = useState(null);
  const [search, setSearch] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [originalData, setOriginalData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fetchRoles = async () => {
    try {
      const response = await roleService.fetchRoles(0);
      const result = response.data?.data.roles || [];
      setRoles(result);
      setOriginalData(result);
    } catch (error) {
      logger.error('Error fetching roles:', error);
      toast.error('Error fetching roles');
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const openMenu = (event, role) => {
    setAnchorEl(event.currentTarget);
    setSelectedRole(role);
  };

  const handleReset = () => {
    setSearch('');
    setRoles(originalData);
  };

  const navigate = useNavigate();
  const closeMenu = () => {
    setAnchorEl(null);
  };

  const openRoleDialog = (role = null, edit = false) => {
    setIsEditMode(edit);
    if (role) {
      setRoleName(role.roleName);
      setRoleDescription(role.description || '');
      setPermissions(role.permissions || initialPermissions);
      setSelectedRole(role);
    } else {
      resetForm();
    }
    setOpenDialog(true);
  };

  const handleEditRole = async () => {
    if (validateInputs()) {
      try {
        const updatedRole = {
          roleName,
          description: roleDescription,
          permissions,
        };
        await roleService.updateRole(selectedRole.roleId, updatedRole);
        toast.success('Role updated successfully');
        fetchRoles();
        closeRoleDialog();
      } catch (error) {
        logger.error('Error editing role:', error);
        toast.error('Error updating role');
      }
    }
  };

  const closeRoleDialog = () => {
    resetForm();
    setOpenDialog(false);
  };

  const handleViewDetails = (role, Id) => {
    navigate(`/role/${Id}`, { state: { role } });
  };
  const resetForm = () => {
    setRoleName('');
    setRoleDescription('');
    setPermissions(initialPermissions);
    setSelectedRole(null);
  };

  const validateInputs = () => {
    return roleName.trim() !== '';
  };

  const handleSave = async () => {
    if (validateInputs()) {
      try {
        const newRole = {
          roleName,
          description: roleDescription,
          permissions,
        };
        await roleService.createRole(newRole);
        toast.success('Role created successfully');
        fetchRoles();
        closeRoleDialog();
      } catch (error) {
        logger.error('Error adding role:', error);
        toast.error('Error creating role');
      }
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this role?')) {
      try {
        await roleService.deleteRole(selectedRole.roleId);
        toast.success('Role deleted successfully');
        fetchRoles();
        closeMenu();
      } catch (error) {
        logger.error('Error deleting role:', error);
        toast.error('Error deleting role');
      }
    }
  };

  const togglePermission = (asset, permission) => {
    setPermissions(
      permissions.map((item) =>
        item.asset === asset
          ? { ...item, [permission]: !item[permission] }
          : item,
      ),
    );
  };

  const handleSearch = () => {
    const filteredRoles = originalData.filter((role) =>
      role?.roleName?.toLowerCase().includes(search.toLowerCase()),
    );
    setRoles(filteredRoles);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <h3>Role Management</h3>
          </Box>
          <Divider />

          <Box sx={{ padding: 4 }}>
            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ marginBottom: 3 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      height: '40px',
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        borderWidth: '2px',
                      },
                      '&:hover fieldset': {
                        borderColor: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '14px',
                      padding: '10px 14px',
                    },
                    '& .MuiInputLabel-root': {
                      color: 'gray',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: colors.swiftcarry[100],
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    sx={{
                      bgcolor: colors.swiftcarry[100],
                      '&:hover': {
                        bgcolor: colors.swiftcarry[100],
                      },
                      height: '40px',
                      flex: 1,
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleReset}
                    sx={{
                      borderColor: '#ccc',
                      color: '#666',
                      height: '40px',
                      flex: 1,
                      '&:hover': {
                        borderColor: colors.swiftcarry[100],
                        color: colors.swiftcarry[100],
                        backgroundColor: `${colors.swiftcarry[100]}10`,
                      },
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={5}
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => openRoleDialog(false)}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                    },
                    height: '40px',
                  }}
                >
                  Add
                </Button>
              </Grid>
            </Grid>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Role_Name
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Permissions
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {roles
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.roleId}>
                        <TableCell>{row.roleName}</TableCell>
                        <TableCell>
                          {row.permissions &&
                            row.permissions
                              .filter(
                                (perm) => perm.read || perm.write || perm.delete,
                              )
                              .map((perm, i) => (
                                <div key={i}>
                                  <strong>{perm.asset}:</strong>{' '}
                                  {perm.read && 'Read '}
                                  {perm.write && 'Write '}
                                  {perm.delete && 'Delete'}
                                </div>
                              ))}
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={(event) => openMenu(event, row)}>
                            <Settings />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={roles.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiToolbar-root': {
                  display: 'flex',
                  width: '500px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-actions': {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                },
                '& .MuiTablePagination-input': {
                  minWidth: '30px',
                },
              }}
            />
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={closeMenu}
            >
              <MenuItem
                onClick={() => {
                  openRoleDialog(selectedRole, true);
                  closeMenu();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </Box>
        </CardContent>
      </Card>

      <Dialog
        open={openDialog}
        onClose={closeRoleDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{selectedRole ? 'Edit Role' : 'Add Role'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Role Name"
                name="roleName"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                required
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: colors.swiftcarry[100],
                      color: colors.swiftcarry[100],
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: 'gray',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: colors.swiftcarry[100],
                  },
                  marginTop: '10px',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextareaAutosize
                minRows={3}
                placeholder="Description"
                value={roleDescription}
                onChange={(e) => setRoleDescription(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  fontSize: '16px',
                  outline: 'none',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Permissions
              </Typography>
              <div style={{ overflow: 'hidden' }}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Permissions</TableCell>
                        <TableCell align="center">Read</TableCell>
                        <TableCell align="center">Write</TableCell>
                        <TableCell align="center">Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {permissions.map((permission, index) => (
                        <TableRow key={index}>
                          <TableCell>{permission.asset}</TableCell>
                          {['read', 'write', 'delete'].map((permType) => (
                            <TableCell align="center" key={permType}>
                              <Checkbox
                                checked={permission[permType]}
                                onChange={() =>
                                  togglePermission(permission.asset, permType)
                                }
                                sx={{
                                  '&.Mui-checked': {
                                    color: colors.swiftcarry[100],
                                  },
                                }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={closeRoleDialog}
                sx={{
                  borderColor: colors.swiftcarry[100],
                  color: colors.swiftcarry[100],
                  '&:hover': {
                    borderColor: colors.swiftcarry[100],
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={isEditMode ? handleEditRole : handleSave}
                sx={{
                  bgcolor: colors.swiftcarry[100],
                  '&:hover': {
                    bgcolor: colors.swiftcarry[100],
                  },
                }}
              >
                {isEditMode ? 'Save Changes' : 'Add'}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Role;
